import React from 'react';
import { ContainerTexto, Title, TitleContainer, Text, ContainerAnchor, FixedAnchor } from '../styles';
import LoginPageImg from '../../../assets/img/ajuda/login.svg';
import { Anchor } from 'antd';

const Geral: React.FC = () => {
  const { Link } = Anchor;


  return (
    <ContainerAnchor>
      <ContainerTexto>
        <TitleContainer id="geral-inicio">Geral</TitleContainer>
        <Text>
          Por onde eu acesso o Portal Kothe Log da Kothe? Para acessar via web digite no seu
          navegador o link:{' '}
          <a href="http://log.kothe.com.br/login" rel="link/external" target="">
            http://log.kothe.com.br/login
          </a>
        </Text>
        <img src={LoginPageImg} alt="pagina de login do portal kothelog" />

        <Title id="geral-cabecario">Cabeçalho</Title>
        <Text>
          O Portal Kothe Log também possui um cabeçalho fixo com algumas funcionalidades à direita,
          onde o usuário pode selecionar de qual centro de distribuição e quais inscrições estaduais
          ele deseja visualizar suas informações. Esses filtros são aplicados em todas as telas do
          portal. Nesse cabeçalho o usuário também pode acessar as suas informações de conta
          clicando em seu perfil e acessando a página “Meus Dados”.
        </Text>

        <Text>
          O usuário pode trocar o tema de cores do portal entre claro e escuro, ou deslogar do
          sistema em “Sair”. Além disso, o usuário também pode recolher o menu clicando no botão à
          esquerda no cabeçalho.
        </Text>

        <Title id="geral-meusDados">Meus Dados</Title>

        <Text>
          Em “Meus dados” o usuário poderá alterar seu nome, sua senha e seu avatar. Bem como
          consultar suas inscrições estaduais e selecionar suas favoritas. Inscrições estaduais
          favoritas são pré-selecionadas ao acessar o portal.
        </Text>

        <Title id="geral-listagem">Listagens</Title>

        <Text>
          Todas as tabelas do sistema podem ser reordenadas por qualquer coluna, também é possível
          alterar o tamanho de cada página para melhor visualização dos dados.
        </Text>
      </ContainerTexto>

      <FixedAnchor >
        <Link title="Início" href='#geral-inicio' />
        <Link title="Cabeçalho" href='#geral-cabecario' />
        <Link title="Meus Dados" href='#geral-meusDados' />
        <Link title="Listagens" href='#geral-listagem' />
      </FixedAnchor>
    </ContainerAnchor>

  );
};

export default Geral;
